<template>
  <!-- 班级主页 -->
  <div class="my-home">
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="finishText"
      @load="handleGetPostList"
    >
      <ul class="home-menu" v-if="list.length > 0">
        <li class="menu-li"  v-for="(item, index) in list"
        :key="index" @click="handleClickItems(item, 'comment')">
          <template v-if="item.type !== 5">
            <div class="li-head">
              <img src="../../../assets/images/grade/home-iep.png" alt="" v-if="item.type === 6">
              <img src="../../../assets/images/grade/home-answer.png" alt="" v-if="item.type === 7">
              <img src="../../../assets/images/grade/home-mock.png" alt="" v-if="item.type === 8">
              <img src="../../../assets/images/grade/icon-examine.png" alt="" v-if="item.type === 9">
              <p class="head-title">{{typeTitle[item.type]}}</p>
            </div>
            <ul class="item">
              <li class="item-li" v-if="item.type === 6 || item.type === 9">
                <p class="label">内容:</p>
                <div class="value">
                  <p class="value-title" v-html="item.classContent"></p>
                </div>
              </li>
              <li class="item-li" v-if="[7].includes(item.type)">
                <p class="label">主题:</p>
                <div class="value">
                  <p class="value-title">{{ item && item.goal }}</p>
                </div>
              </li>
              <li class="item-li" v-if="item.type === 8">
                <p class="label">类型:</p>
                <div class="value">
                  <p class="value-title">{{ item && item.simulatorName }}</p>
                </div>
              </li>
              <li class="item-li">
                <p class="label">时间:</p>
                <div class="value">
                  <p class="value-title">{{ item && item.dataTime }}</p>
                </div>
              </li>
              <li class="item-li" v-if="[6, 8].includes(item.type)">
                <p class="label">地点:</p>
                <div class="value">
                  <p class="value-title">{{ item && item.place }}</p>
                </div>
              </li>
              <li class="item-li" v-if="item.type === 7 || item.type === 9">
                <p class="label">链接:</p>
                <div class="value" v-if="item.type === 7">
                  <div class="flex-val">
                    <div class="btn" v-track="{ functionName: '班级-进入会议' }" @click="handleGoMeeting(item)">进入会议</div>
                    <p class="val-title">{{meetingStatusList[item.meetingStatus]}}</p>
                  </div>
                </div>
                <div class="value" v-if="item.type === 9">
                  <div class="flex-val">
                    <div class="btn" v-track="{ functionName: '进入班级考试' }" @click.stop="handleGoAnswer(item)">进入考试</div>
                  </div>
                </div>
              </li>
            </ul>
            <div class="footer" v-if="isAdminPermiss && !([9, 10].includes(item.type))">
              <p class="user">
                <span class="num">{{ item && item.confirmNum }}</span>
                已确认
              </p>
              <i class="hen"></i>
              <p class="user">
                <span class="num">{{ item && item.nonConfirmNum }}</span>
                未确认
              </p>
            </div>
            <div class="inform" v-if="commonPer">
              <img src="../../../assets/images/grade/icon-inform.png" alt="" class="icon-inform"/>
              <p class="inform-title">这条通知你{{item.isConfirm == 0?'还没':'已'}}确认</p>
              <div class="inform-btn" :class="item.isConfirm == 0?'active':''"
              @click.stop="handleConfirm(item.id,index)">{{item.isConfirm == 0?'去':'已'}}确认</div>
            </div>
          </template>
          <template v-else>
            <div class="user-head">
              <img :src="item.headPicUrl" alt="" class="icon-user">
              <div class="head-right">
                <p class="right-title">{{ item.userIdentity === 1?'管理员' : item.realName }}</p>
                <p class="right-time">{{ item.times }}</p>
              </div>
            </div>
            <div class="user-main">
              <p class="main-title">{{ item.subjectName }}</p>
              <div class="main-content" v-html="item.content"></div>
              <div class="main-imgList">
                <div class="imgs-mask" v-if="item.isMoreImgs">
                  +{{ item.moreNum }}
                </div>
                <img v-for="(citem,cindex) in item.contentFile" :key="cindex"
                :src="citem.url" alt="" class="img-cover"
                />
              </div>
              <div class="item-imgs" v-if="item.videoInfo && Object.keys(item.videoInfo).length > 0">
                <div class="video-block" v-if="!item.isPlayVideo" @click.stop="handleClickItemsVideo(item, index)">
                  <div v-if="item.coverInfo" :style="`background-image: url(${item.coverInfo.url});`"
                    class="video-cover" alt=""></div>
                  <div v-else :style="`background-image: url(${item.videoInfo.outUrl || item.videoInfo.path});`"
                    class="video-cover" alt=""></div>
                  <img src="@/assets/images/course/icon-play-course.png" class="icon-video" alt="" />
                </div>
                <VideoPlayerAnswer v-else ref="video" @handlePlay="handlePlay" :playerVideo="item.videoInfo">
                </VideoPlayerAnswer>
                <!-- <img :src="item.videoInfo.outUrl || item.videoInfo.path" class="video-cover" alt="">
                <img src="@/assets/images/course/icon-play-course.png" class="icon-video" alt=""> -->
              </div>
              <ul class="comment" v-if="item.commentDTOS && item.commentDTOS.length > 0" @click="handleClickItems(item, 'comment')">
                <li class="comment-li"  v-for="(item_comm, index_comm) in item.commentDTOS" :key="index_comm">
                  <img :src="item_comm.headPicUrl" alt="" class="img"/>
                  <p class="comment-title">{{ item_comm.content }}</p>
                </li>
              </ul>
              <ul class="user-footer">
                <li class="footer-li">
                  <img src="../../../assets/student/icon_see.png" alt="" class="icon-btm1">
                  <p class="num">{{ item.visitNum || 0 }}</p>
                </li>
                <li class="footer-li">
                  <img src="../../../assets/student/info.png" alt="" class="icon-btm1">
                  <p class="num">{{ item.commentNum || 0 }}</p>
                </li>
                <li class="footer-li" @click.stop="handleLike(item, index)" v-if="isAdminPermiss || commonPer">
                  <img src="@/assets/images/zone/img20.png" v-if="item.isLike + '' === '1'" alt="" class="icon-btm1">
                  <img src="@/assets/images/zone/img17.png" v-if="item.isLike + '' === '2'" class="icon-btm1" alt="" />
                  <p class="num">{{ item.likeNum || 0 }}</p>
                </li>
                <li class="footer-li" v-else>
                  <img src="@/assets/images/zone/img20.png" v-if="item.isLike + '' === '1'" alt="" class="icon-btm1">
                  <img src="@/assets/images/zone/img17.png" v-if="item.isLike + '' === '2'" class="icon-btm1" alt="" />
                  <p class="num">{{ item.likeNum || 0 }}</p>
                </li>
              </ul>
            </div>
          </template>
        </li>
      </ul>
    </van-list>
    <div class="empty-block" v-if="!list.length">
      <img src="@/assets/images/zone/img18.png" class="empty-img" alt="" />
      <div class="empty-txt">暂无内容</div>
    </div>
    <dialogDel ref="dialogDel" @handleDelSave="handleDelSave" :dialogHeadTxt="dialogHeadTxt" :delMessage="delMessage"></dialogDel>
  </div>
</template>
<script>
import { postCardPage, userConfirm } from '@/api/grade'
import { typeTitle, meetingStatusList } from '../data'
import { postLike, delLike, visitAdd } from '@/api/zone'
import VideoPlayerAnswer from '../../home/components/VideoPlayerAnswer.vue'
import {debounce} from '@/utils/util'
import dialogDel from './dialogDel.vue'
export default {
  name: 'gradeHomeList',
  components: {
    VideoPlayerAnswer,
    dialogDel
  },
  props: {
    classId: '',
    isAdminPermiss: false, // 超管 管理员
    commonPer: false, // 普通员工 发普通帖子，点赞评论
  },
  data() {
    return {
      typeTitle,
      meetingStatusList,
      list: [],
      loading: false,
      finished: false,
      pageObj: {
        pageNo: 1,
        pageSize: 10
      },
      searchContent: '',
      isNone: false,
      finishText: '没有更多了',
      delMessage: '确认删除吗?',
      dialogHeadTxt: '提示'
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    },
  },
  async created() {
    this.classId = this.$route.query.classId
  },
  methods: {
    handleDelSave (item) {
      if (this.dialogConType === 'gradeQuestion') {
        this.$router.push({
          path: '/gradeQuestion',
          query: {
            postbarId: item.id,
            noneHasResult: true
          }
        })
      }
    },
    handleGoAnswer(item) {
      sessionStorage.setItem('traceObj', JSON.stringify({
        functionUrl: '/gradeQuestion',
        note: `postId=${item.id}&classId=${this.classId}`
      }))
      if (item.userInspectBusiness) {
        this.$router.push({
          path: '/gradeQuestion',
          query: {
            postbarId: item.id,
          }
        })
      } else if (item.userInspectComplete) {
        this.$router.push({
          path: '/gradeQuestion',
          query: {
            postbarId: item.id,
            noneHasResult: true
          }
        })
      } else {
        this.dialogHeadTxt = '进入考试'
        const str = item.userResidueInspectNum >= 0 ? `, 还剩<span style="color: #EB1700;">${item.userResidueInspectNum}</span>次！` : ''
        this.delMessage = `您好，您本场考试的答题次数为第${item.userInspectNum}次${str}`
        this.$refs.dialogDel.init(item)
        this.dialogConType = 'gradeQuestion'
      }
    },
    handleLike: debounce(function(item, index) {
      if (item.isLike === '1' || item.isLike === 1) {
        delLike({ id: item.likeBaseId }).then(() => {
          this.list[index].likeNum--
          this.$toast('取消点赞成功')
          this.list[index].isLike = '2'
          this.$forceUpdate()
        })
        return
      }
      let params = {
        likeId: item.id,
        likeTitle: item.subjectName,
        userId: this.userInfo.id,
        targetUserId: item.userId,
        targetUserName: this.userInfo.realName,
        targetHeadPic: item.headPicUrl,
        kind: 7,
        type: 7
      }
      if (item.contentFile && item.contentFile.length > 0) {
        params.cover = item.contentFile[0].url
      }
      if (item.liveDTO && item.liveDTO.length > 0) {
        params.cover = item.liveDTO[0].liveCover
      }
      if (item.coverInfo && item.coverInfo.url) {
        params.cover = item.coverInfo.url
      }
      postLike(params).then(res => {
        this.list[index].likeNum++
        this.list[index].likeBaseId = res.data
        this.list[index].isLike = '1'
        this.$forceUpdate()
        this.$toast('点赞成功')
      })
    }, 500),
    // 确认消息
    handleConfirm: debounce(function (postbarId, index) {
      const params = {
        classId: this.classId,
        postbarId,
        userId: this.userInfo.id
      }
      userConfirm(params).then(res => {
        this.$set(this.list[index], 'isConfirm', 1)
        this.$toast('确认成功')
      }).catch(err => {
        this.$toast(err.msg)
      })
    }, 500),
    handleClickItemsVideo (item, index) {
      this.list[index].isPlayVideo = !item.isPlayVideo
      let params = {
        userId: this.userInfo.id,
        postbarId: item.id,
        subjectName: item.subjectName
      }
      visitAdd(params)
      setTimeout(() => {
        let videos = this.$refs.video
        for (let i in videos) {
          if (videos[i].playerVideo.id === item.id) {
            videos[i].player.play()
          }
        }
      })
    },
    handlePlay (e) {
      let videos = this.$refs.video
      for (let i in videos) {
        if (videos[i].playerVideo.id !== e.id) {
          videos[i].player.pause()
        }
      }
    },
    handleClickItems (item, type) {
      if (item.type === 5) {
        let isAuthority = (this.commonPer || this.isAdminPermiss)
        let path = '/topicDetail'
        let query = type === 'comment' ? {
          postId: item.id,
          type: 'comment',
          classId: this.$route.query.classId,
          entrance: 55,
          channel: 55,
          businessId: this.$route.query.classId,
          isAuthority: isAuthority
        } : {
          postId: item.id,
          classId: this.$route.query.classId,
          entrance: 55,
          channel: 55,
          businessId: this.$route.query.classId,
          isAuthority: isAuthority
        }
        this.$router.push({
          path, query
        })
      } else {
        const PATHS2 = {
          6: '/iepDetails',
          7: '/answerDetails',
          8: '/mockDetails',
          9: '/examineDetail'
        }
        let path = PATHS2[item.type]
        this.$router.push({
          path: `${path}?postId=${item.id}&classId=${this.$route.query.classId}&commonPer=${this.commonPer}`
        })
      }
    },
    // 进入会议
    handleGoMeeting (item) {
      sessionStorage.setItem('traceObj', JSON.stringify({
        functionUrl: item.onlineLink,
        note: `postId=${item.id}&classId=${this.classId}`
      }))
      window.open(item.onlineLink)
    },
    handleGetPostList() {
      let params = {
        searchContent: this.searchContent,
        pageNum: this.pageObj.pageNo,
        pageSize: this.pageObj.pageSize,
        areaId: this.classId,
        userId: this.userInfo.id,
        memberType: this.userInfo.memberType,
      }
      postCardPage(params)
        .then(res => {
          this.$toast.clear()
          if (res) {
            if (res.code !== 0 || !res.data || !res.data.list) {
              this.loading = false
              this.finished = true
              return false
            }

            this.loading = false
            res.data.list = res.data.list.map(item => {
              item.startTime = this.$moment(item.startTime * 1).format(
                'YYYY-MM-DD HH:mm'
              )
              item.endTime = this.$moment(item.endTime * 1).format(
                'YYYY-MM-DD HH:mm'
              )
              item.times = this.$moment(item.auditTime * 1).format(
                'MM-DD HH:mm'
              )
              item.dataTime = `${item.startTime} ~ ${item.endTime}`
              item.curTimes = item.cutTime ? this.$moment(item.cutTime * 1).format('YYYY/MM/DD HH:mm') : ''
              if (item.contentFile.length > 3) {
                item.isMoreImgs = true
                item.moreNum = item.contentFile.length - 3
              }
              item.contentFile = item.contentFile.splice(0, 3)
              if (item.videoInfo) {
                item.isPlayVideo = false
                item.videoInfo.sectionId = item.videoInfo.id
                item.videoInfo.path = encodeURI(item.videoInfo.path)
                item.videoInfo.outUrl = encodeURI(item.videoInfo.outUrl)
              }
              if (item.voteListSelectedDTOS && item.voteListSelectedDTOS.length > 0) {
                item.allVotePerson = 0
                item.voteListSelectedDTOS.map(items => {
                  item.allVotePerson += items.selectNum
                })
                item.voteAll = !(item.voteListSelectedDTOS.length > 3)
                item.isChecked = !(item.voteListSelectedDTOS.filter(res => res.isSelected).length > 0)
              }
              return item
            })
            if (res.data.list.length < this.pageObj.pageSize) {
              this.finished = true
            }
            // res.data.list.map(item => {
            //   if(this.userInfo.memberType == 0 && ACCESS_TOKEN. ) {
            //     item.isBtnOk =
            //   }

            // })
            if (res.code === 0 && res.data.list) {
              this.list = this.list.concat(res.data.list)
            }
            this.pageObj.pageNo++
            if (this.list.length === 0) {
              this.isNone = true
              this.finishText = ''
            }
          }
        })
        .catch(err => {
          this.$toast.clear()
          console.log('err:', err)
        })
    }
  }
}
</script>
<style scoped lang="less">
.my-home{
  position: relative;
  padding: 10px 16px;
  .home-menu{
    margin:0;
    padding:0;
    .menu-li{
      border-radius: 12px;
      // height: 201px;
      background: #FFFFFF;
      margin-bottom: 12px;
      position: relative;
      display: flex;
      flex-direction: column;
      .li-head{
        border-radius: 12px 12px 0 0;
        height: 41px;
        position: relative;
        display: flex;
        align-items: center;
        padding: 9px 9px 8px;
        box-sizing: border-box;
        border: 1.5px solid rgb(255, 255, 255);
        background: linear-gradient(90.00deg, rgb(241, 239, 237),rgb(255, 255, 255) 100%);

        img{
          width: 24px;
          height: 24px;
          margin-right: 4px;
        }
        .head-title{
          font-weight: 600;
          font-size: 14px;
          color: #202020;
        }
      }
      .item{
        // flex:1;
        height: calc(100% - 41px - 42px);
        position: relative;
        padding:10px 30px 10px 12px;
        .item-li{
          display: flex;
          align-items: center;
          position: relative;
          margin-bottom: 12px;
          &:last-child{
            margin-bottom: 0;
          }
          .label{
            font-weight: 500;
            font-size: 14px;
            color: #7A8494;
            margin-right: 6px;
          }
          .value{
            flex: 1;
            overflow: hidden;
            .value-title{
              width: 100%;
              font-weight: 500;
              font-size: 14px;
              color: #000000;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .flex-val{
              display: flex;
              align-items: center;
              .btn{
                width: 89px;
                height: 32px;
                background: #EB1700;
                border-radius: 25px;
                margin-right: 10px;
                font-size: 12px;
                color: #FFFFFF;
                text-align: center;
                line-height: 31px;
              }
              .val-title{
                font-weight: 500;
                font-size: 14px;
                color: #7A8494;
              }
            }

          }
        }
      }
      .footer{
        display: flex;
        align-items: center;
        margin:0 10px 12px;
        height: 42px;
        box-sizing: border-box;
        position: relative;
        background: #F9F8F7;
        border-radius: 4px;
        padding:10px 0;
        .user{
          flex: 1;
          align-items: center;
          display: flex;
          justify-content: center;
          font-size: 12px;
          color: #EB1700;
          .num{
            font-weight: bold;
            font-size: 16px;
            color: #000000;
            padding-right: 4px;
          }
        }
        .hen{
          position: relative;
          top: 2px;
          width: 0;
          height: 11px;
          border: 1px solid #C7CCD3;
        }
      }
      .inform{
        margin:0 10px 12px;
        position: relative;
        height: 32px;
        background: #F9F8F7;
        border-radius: 4px;
        display: flex;
        align-items: center;
        padding:2px 4px;
        .icon-inform{
          width: 28px;
          height: 28px;
          margin-right: 2px;
        }
        .inform-title{
          font-size: 14px;
          color: #202020;
          flex: 1;
        }
        .inform-btn{
          width: 52px;
          height: 24px;
          background: #FFFFFF;
          border-radius: 14px 14px 14px 14px;
          border: 1px solid #C4C4C4;
          text-align: center;
          color: #B7B6B6;
          font-size: 12px;
          line-height: 24px;
          &.active{
            background: #EB1700;
            box-shadow: 0px 2px 4px 0px rgba(255,91,12,0.25);
            border-radius: 20px 20px 20px 20px;
            font-size: 12px;
            color: #FFFFFF;
            text-align: center;
            line-height: 24px;
            border:none;
          }
        }

      }
      .user-head{
        position: relative;
        background: linear-gradient( 90deg, #FDF3F3 0%, #FFFDFD 100%);
        border: 2px solid #FFFFFF;
        display: flex;
        align-items: center;
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;
        padding:10px 10px 4px;
        height: 52px;
        box-sizing: border-box;
        .icon-user{
          width: 32px;
          height: 32px;
          border-radius: 50%;
          margin-right: 4px;
        }
        .head-right{
          display: flex;
          flex-direction: column;
          position: relative;
          .right-title{
            font-size: 14px;
            color: #EB1700;
          }
          .right-time{
            font-weight: 500;
            font-size: 12px;
            color: #7A8494;
          }
        }
      }
      .user-main{
        padding:10px 12px;
        position: relative;
        display: flex;
        flex-direction: column;
        .main-title{
          font-weight: 600;
          font-size: 14px;
          color: #202020;
          margin-bottom: 2px;
        }
        .main-content{
          font-size: 13px;
          color: #7A8494;
          display: -webkit-box;
          /* 盒子类型 */
          word-break: break-all;
          /* 自动换行的处理方法。允许在单词内换行 */
          text-overflow: ellipsis;
          /* 溢出时用... */
          overflow: hidden;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          /* 最大行数 */
        }
        .main-imgList{
          display: flex;
          position: relative;
          flex-wrap: nowrap;
          .img-cover {
            width: 103px;
            margin-right: 8px;
            height: 103px;
            display: block;
            border-radius: 5px;
            object-fit: cover;

            &:nth-last-child(1) {
              margin-right: 0;
            }
          }

          .imgs-mask {
            position: absolute;
            right: -2px;
            top: 0;
            width: 103px;
            height: 103px;
            background: rgba(0,0,0,0.5);
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 24px;
            color: #fff;
          }

        }
        .comment{
          margin-top: 14px;

          position: relative;
          .comment-li{
            display: flex;
            align-items: center;
            margin-bottom: 8px;

            .img{
              width: 18px;
              height: 18px;
              border-radius: 50%;
              margin-right: 4px;
            }
            .comment-title{
              font-size: 12px;
              color: #343434;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
        .video-block {
          width: 100%;
          height: 200px;
          position: relative;

          .video-cover {
            display: block;
            width: 100%;
            height: 200px;
            position: relative;
            background-repeat: no-repeat;
            background-size: contain;
            background-position: center;
          }
          .icon-video {
            position: absolute;
            width: 40px;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
          }
        }

        .user-footer{
          margin-top: 12px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .footer-li{
            display: flex;
            align-items: center;
            .icon-btm1{
              width: 16px;
              margin-right: 4px;
              display: block;
            }
            .num{
              font-weight: 600;
              line-height: 16px;
              font-size: 12px;
              color: #7a8494;
              display: block;
            }
          }
        }
      }
    }
  }
}
.empty-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 60px;

  .empty-img {
    width: 185px;
    display: block;
    margin-bottom: 4px;
  }

  .empty-txt {
    font-size: 12px;
    color: #949ba5;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/grade/components/homeList.vue